function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import createLogger from './createLogger';
import loadScript from './loadScript';
function capitialize(str) {
  if (str === void 0) {
    str = '';
  }
  str = typeof str === 'string' ? str : str + '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
function isTypeFactory(type) {
  return function (val) {
    return Object.prototype.toString.call(val) === "[object " + capitialize(type) + "]";
  };
}
export var isObject = isTypeFactory('object');
export var isArray = isTypeFactory('array');
export var isNumber = isTypeFactory('number');
export var isString = isTypeFactory('string');
export var isNull = isTypeFactory('null');
export var isUndefined = isTypeFactory('undefined');
export { createLogger, loadScript };
var istype = {
  isObject: isObject,
  isArray: isArray,
  isNumber: isNumber,
  isString: isString,
  isNull: isNull,
  isUndefined: isUndefined
};
export default _extends({}, istype, {
  createLogger: createLogger,
  loadScript: loadScript
});